export default "__VITE_ASSET__708b1b94__"